import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = ["id"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Viewer2D = _resolveComponent("Viewer2D", true);
    const _component_Popup = _resolveComponent("Popup");
    return (_openBlock(), _createElementBlock("div", {
        ref: "smiles-container",
        class: "mb-4",
        style: _normalizeStyle(_ctx.containerStyles)
    }, [
        (_openBlock(), _createElementBlock("svg", {
            onClick: _cache[0] || (_cache[0] =
                //@ts-ignore
                (...args) => (_ctx.onClick && _ctx.onClick(...args))),
            style: _normalizeStyle(_ctx.svgStyles),
            id: _ctx.id,
            ref: "output-svg",
            viewbox: "0 0 0 0",
            xmlns: "http://www.w3.org/2000/svg"
        }, null, 12, _hoisted_1)),
        (!_ctx.inPopup)
            ? (_openBlock(), _createBlock(_component_Popup, {
                key: 0,
                modelValue: _ctx.showSmilesPopup,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.showSmilesPopup) = $event)),
                title: "Molecular Structure",
                cancelBtnTxt: "Close",
                id: "molStructure"
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_Viewer2D, {
                        smiles: _ctx.smiles,
                        inPopup: true
                    }, null, 8, ["smiles"])
                ]),
                _: 1
            }, 8, ["modelValue"]))
            : _createCommentVNode("", true)
    ], 4));
}
